import { Skeleton, Stack, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	isLast: boolean;
};

export const DashboardDetailRowSkeleton: FC<Props> = ({ isLast }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={1.2}
			px={1.6}
			py={1.2}
			borderBottom={isLast ? 0 : 1}
			borderColor="surface.border"
		>
			<Skeleton
				variant="rounded"
				width={40}
				height={40}
				sx={{ borderRadius: theme.radii.lg, flexShrink: 0 }}
			/>
			<Stack flex={1} gap={0.6}>
				<Skeleton variant="rounded" width="55%" height={14} />
				<Skeleton variant="rounded" width="35%" height={12} />
			</Stack>
			<Skeleton variant="rounded" width={72} height={14} />
		</Stack>
	);
};
